import {toJS} from 'mobx';
import * as React from 'react';
import {FunctionComponent, useRef} from 'react';

import {useContainerDimensions} from '../helpers/hooks';
import {GraphPillDto, GraphTimeSpan} from '../swagger';
import {ErrorsChartElement} from './ErrorsChartElement';
import {ErrorsChartElementState} from './ErrorsChartElementState';
import moment from 'moment';

export interface ErrorsChartProps {
    containerPadding: number;
    graphTimeSpan: GraphTimeSpan;
    items: GraphPillDto[] | null | undefined;
    logsIds: string[];
    small?: boolean;
}

const dateFormatDay = 'yyyyMMDD';
const dateFormatHour = 'yyyyMMDDHH';

export const errorChartElementStates: Map<string, ErrorsChartElementState> = new Map<string, ErrorsChartElementState>();


export const ErrorsChart: FunctionComponent<ErrorsChartProps> =
    ({containerPadding, logsIds, items, graphTimeSpan, small}) => {
        items = toJS(items);
        const componentRef = useRef<HTMLHeadingElement>();
        let {width} = useContainerDimensions(componentRef);
        width = width - containerPadding;

        let current = moment().utc();
        const graphData: Map<string, GraphPillDto> = new Map<string, GraphPillDto>();

        const duration =
            graphTimeSpan === GraphTimeSpan.Hour ? 1 : 24;

        const dateFormat = graphTimeSpan === GraphTimeSpan.Hour ? dateFormatHour : dateFormatDay;

        graphData.set(current.format(dateFormat), {});
        let maxCount = width / 12;
        if (maxCount > 100) {
            maxCount = 100;
        }

        for (let i = 0; i < maxCount; i++) {
            current = current.subtract(duration, 'hours');
            const formatted = current.format(dateFormat);
            //TODO: Dodać jak jest duplikat //const severityArray = Object.values(Severity);
            graphData.set(formatted, {key: formatted});
        }

        if (items) {
            items.forEach((i) => {
                if (graphData.has(i.key!)) {
                    graphData.set(i.key!, i);
                }
            });
        }

        return (
            <div ref={componentRef as any} className="flex w-full">
                {Array.from(graphData.keys()).map((k, i) => {
                    const stateKey = k + logsIds.join('') + graphTimeSpan;
                    if (!errorChartElementStates.has(stateKey)) {
                        errorChartElementStates.set(stateKey, new ErrorsChartElementState(k, graphTimeSpan));
                    }

                    return <ErrorsChartElement
                        blink={i === 0 && errorChartElementStates.get(stateKey)!.items.length > 0}
                        state={errorChartElementStates.get(stateKey)!}
                        logsIds={logsIds}
                        small={small}
                        pillData={graphData.get(k)!}
                        key={k + 'gc'}/>;
                })}
            </div>
        );
    };
